<template src="./PartnershipsForm.html" />

<script>
import { computed, defineComponent } from "vue"
import moment from "moment"

import { useStore } from "@/store/store.js"
import { FilesHelper } from '@/helpers/FilesHelper'
import mixins from "@/Mixins.js"
import icImageUpload from "@/assets/images/icons/icUploadImage.png"
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue"

export default defineComponent({
  name: "PartnershipsForm",
  props: {
    agentId: {
      type: Number | null,
      default: null
    }
  },
  mixins: [mixins],
  components: { WholeMultiselect },
  data () {
    return {
      file: null,
      clientId: null,
      partnerId: null,
      partners: [],
      openCollapse: true,
      documentRegistered: false,
      logo: null,
      name: null,
      documentType: "cpf",
      document: null,
      gender: null,
      birthdate: null,
      email: null,
      zipcode: "",
      city: "",
      complement: "",
      number: "",
      state: "",
      street: "",
      aasUserId: null,
      validZipcode: true,
      contact: null,
      phone: null,
      invalidFields: {
        name: false,
        gender: false,
        cpf: false,
        cnpj: false,
        birthdate: false,
        email: false,
        zipcode: false,
        city: false,
        number: false,
        state: false,
        street: false,
        contact: false,
        phone: false,
        consultationPaymentMethod: false
      },
      genderOptions: [
        { text: "Feminino", value: "F" },
        { text: "Masculino", value: "M" },
        { text: "Indefinido", value: "N/A" }
      ],
      documentsOptions: [
        { text: "CPF", value: "cpf" },
        { text: "CNPJ", value: "cnpj" },
      ],
      disable: {
        street: false,
        city: false,
        state: false
      },
      saveClicked: false,
      modalLogoUploadError: false,
      modalLogoError: '',
      consultationPaymentMethodOptions: [
        { name: "Carteira Virtual", value: 'VIRTUAL_WALLET_PAYMENT' },
        { name: "Pagamento na Clínica", value: 'CLINIC_PAYMENT' },
      ],
      consultationPaymentMethod: null,
    }
  },
  setup () {
    const store = useStore()

    return {
      iconImageUpload: icImageUpload,
      filooServer: computed(() => store.state.filooServer),
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
      setPartnerLogo: (payload) => store.dispatch("setPartnerLogo", payload),
    }
  },
  computed: {
    computedInputImageIcon () {
      return !this.logo ? `url(${this.iconImageUpload})` : ''
    },
    computedInputImage () {
      return this.logo ? `url(${this.logo})` : ''
    },
    showButtonBack () {
      return !!this.agentId
    }
  },
  async mounted () {
    if (this.agentId) {
      this.getAgentData()
    }
    this.getPartners()
  },
  watch: {
    name (newVal) {
      this.invalidFields.name = !newVal && this.saveClicked
    },
    gender (newVal) {
      this.invalidFields.gender = !newVal && this.saveClicked
    },
    document (newVal) {
      if (this.documentType === "cpf") {
        (this.invalidFields.cpf = !newVal || this.documentRegistered) && this.saveClicked
      }
      if (this.documentType === "cnpj") {
        (this.invalidFields.cnpj = !newVal || this.documentRegistered) && this.saveClicked
      }
    },
    birthdate (newVal) {
      this.invalidFields.birthdate = !this.validateBirthDate(newVal) && this.saveClicked
    },
    email (newVal) {
      this.invalidFields.email = !this.validateEmail(newVal) && this.saveClicked
    },
    state (newVal) {
      this.invalidFields.state = !newVal && this.saveClicked
    },
    city (newVal) {
      this.invalidFields.city = !newVal && this.saveClicked
    },
    number (newVal) {
      this.invalidFields.number = !newVal && this.saveClicked
    },
    street (newVal) {
      this.invalidFields.street = !newVal && this.saveClicked
    },
    zipcode (newVal) {
      this.invalidFields.zipcode = (!newVal || !this.validZipcode) && this.saveClicked
    },
    contact (newVal) {
      this.invalidFields.contact = !newVal && this.saveClicked
    },
    phone (newVal) {
      this.invalidFields.phone = !newVal && this.saveClicked
    },
  },
  methods: {
    getAgentData () {
      this.axios.get(
        `${this.$store.state.filooServer}partner/${this.agentId}`,
        { id: this.agentId },
        { headers: { Authorization: this.$session.get("bearer") } }
      )
        .then(({ status, data }) => {
          if (status === 200) {
            this.fillFieldsAgentData(data)
          }
        })
    },
    fillFieldsAgentData (aas) {
      
      this.consultationPaymentMethod = this.consultationPaymentMethodOptions.find(opt => opt.value === aas.consultantPaymentMethod)

      this.aasUserId = aas.id

      this.name = aas.name
      this.email = aas.email
      this.document = aas.document

      this.zipcode = aas.zipcode
      this.street = aas.street
      this.number = aas.number
      this.complement = aas.complement
      this.state = aas.state
      this.city = aas.city
      this.contact = aas.contact
      this.phone = aas.phone
      this.birthdate = aas.birthday.map((dt) => dt.toString().padStart(2, "0")).join("-")
      this.partnerId =  this.partners.find(pack => pack.id === aas.partnerId) || null
      this.clientId = this.partners.find(pack => pack.id === aas.clientId) || null
      
      if (this.document && this.getOnlyNumbers(this.document)) {
        this.documentType = this.getOnlyNumbers(this.document).length > 11 ? "cnpj" : "cpf"
      }

      if (aas.gender) {
        this.gender = this.genderOptions.find((gender) => gender.value === aas.gender)
      }

      if (aas.partnerLogo) {
        const { fileBytes, contentType } = aas.partnerLogo

        this.logo = `data:${contentType};base64,${fileBytes}`
      }
    },
    async getAddress () {
      const response = await this.getAddressByZipcode(this.zipcode)
      this.validZipcode = response && response.address

      if (this.validZipcode) {
        this.zipcode = response.address.zipcode
        this.city = response.address.city
        this.state = response.address.state
        this.street = response.address.street
      } else {
        this.state = ""
        this.street = ""
        this.city = ""
      }

      this.disable.street = !this.validZipcode || !this.street
      this.disable.city = !this.validZipcode || !this.city
      this.disable.state = !this.validZipcode || !this.state
    },
    validateFields () {
      Object.keys(this.invalidFields).forEach((field) => {
        this.invalidFields[field] = !this[field]
      })

      this.invalidFields.consultationPaymentMethod = !this.consultationPaymentMethod;

      this.invalidFields.cnpj = this.documentType === "cnpj"
        ? (!this.document || this.documentRegistered)
        : false

      this.invalidFields.cpf = this.documentType === "cpf"
        ? (!this.document || this.documentRegistered)
        : false

      if (Object.values(this.invalidFields).some((val) => val)) {
        this.$vs.notify({
          title: "Atenção!",
          text: "Campos obrigatórios não preenchidos ou inválidos.",
          color: "warning",
          icon: "error",
          position: "top-right",
          time: 4000,
        })
      } else {
        this.aasUserId ? this.putAAS() : this.postAAS()
      }
    },
    validateDocument (document) {
      this.documentRegistered = false
      this.axios
        .post(
          `${this.$store.state.filooServer}partner/verify-document?document=${document}`,
          this.document,
          {
            headers: { Authorization: this.$session.get("bearer") },
          }
        )
        .then(response => {
          if (response.data !== "" && response.data.id !== this.aasUserId) {
            this.documentRegistered = true
            this.showNotifyWarning(
              "Documento ja cadastrado para outro parceiro",
              3200
            )
          }
        })
        .catch(() => {
        })
    },
    async postAAS () {
      const [year, month, day] = this.birthdate.split("-")
      const payload = {
        name: this.name,
        contact: this.contact,
        document: this.document,
        gender: this.gender.value,
        consultantPaymentMethod: this.consultationPaymentMethod.value,
        phone: this.phone,
        birthday: moment(new Date(year, month - 1, day)).format("YYYY-MM-DD"),
        email: this.email,
        zipcode: this.zipcode,
        street: this.street,
        number: this.number,
        complement: this.complement,
        city: this.city,
        state: this.state,
        clientId: this.clientId && this.clientId.id ? this.clientId.id : null,
        partnerId: this.partnerId && this.partnerId.id ? this.partnerId.id : null,
      }

      try {
        const { status, data } = await this.axios.post(
          `${this.filooServer}partner`,
          payload,
          { headers: { Authorization: this.$session.get("bearer") } }
        )

        if (status === 200) {
          let message = `O Parceiro <b style='color: #FF9F43; font-weight: 500'>${this.name}</b> foi criado com sucesso!`

          let response = null
          if (this.file) {
            const formData = new FormData()
            formData.append("file", this.file)

            response = await this.setPartnerLogo({ id: data.id, formData })
          }

          if (response && !response.success) {
            message += ' Porém o logotipo não foi cadastrado e deve ser enviado novamente.'
          }

          this.$swal("Operação realizada", message, "success").then(() => {
            this.$router.push('/PartnershipsRegistered')
          })
        }
      } catch (error) {
        const errorMessage = error.response.data.message || ''
        if (errorMessage.includes("CPF")) {
          this.$swal(
            "Atenção!",
            "CPF ou CNPJ já utilizado, verifique se o agente já possui cadastro ou digite um novo valor.",
            "error"
          )
        } else {
          this.$swal(
            "Atenção!",
            "Não foi possível realizar esta operação. Por favor contacte o administrador do sistema.",
            "error"
          )
        }
      }
    },
    getPartners() {
      const vm = this;
      this.axios
        .get(`${this.$store.state.filooServer}partner/get-partners`,{
            headers: { Authorization: vm.$session.get("bearerDefault") },
          })
        .then(response => {
          if (response.status === 200) {
            this.partners = response.data;
          }
        });
    },
    putAAS () {
      const [year, month, day] = this.birthdate.split("-")
      const payload = {
        id: this.aasUserId,
        name: this.name,
        contact: this.contact,
        document: this.document,
        gender: this.gender.value,
        consultantPaymentMethod: this.consultationPaymentMethod.value,
        phone: this.phone,
        birthday: moment(new Date(year, month - 1, day)).format("YYYY-MM-DD"),
        email: this.email,
        zipcode: this.zipcode,
        street: this.street,
        number: this.number,
        complement: this.complement,
        city: this.city,
        state: this.state,
        clientId: this.clientId && this.clientId.id ? this.clientId.id : null,
        partnerId: this.partnerId && this.partnerId.id ? this.partnerId.id : null,
      }

      this.axios.put(
        `${this.filooServer}partner`,
        payload,
        { headers: { Authorization: this.$session.get("bearer") } }
      )
        .then(({ status }) => {
          if (status === 200) {
            this.$swal(
              "Operação realizada",
              `O Parceiro <b style='color: #FF9F43; font-weight: 500'>${this.name}</b> foi alterado com sucesso!`,
              "success"
            )
              .then(() => this.goBackToAASList())
          }
        })
        .catch((error) => {
          if (error.data.message.includes("CPF")) {
            this.$swal(
              "Atenção!",
              "CPF ou CNPJ já utilizado, verifique se o agente já possui cadastro ou digite um novo valor.",
              "error"
            )
          } else {
            this.$swal(
              "Atenção!",
              "Não foi possível realizar esta operação. Por favor contacte o administrador do sistema.",
              "error"
            )
          }
        })
    },

    goBackToAASList (event) {
      this.$emit("showTable", event)
    },
    async handleClickLoadImage () {
      this.modalLogoUploadError = false

      const inputImage = this.$refs.fileInput

      inputImage.value = ''
      inputImage.click()
    },
    async previewImage (evt) {
      this.modalLogoError = ''

      if (evt.target.files.length) {
        const file = evt.target.files[0]
        const type = file.name.split('.').pop()
        const reader = await new FileReader()

        if (!FilesHelper.checkExtension(file, ['png', 'svg'])) {
          this.modalLogoError = 'extension'

          return this.modalLogoUploadError = true
        }

        if (!FilesHelper.checkSize(file, type === 'png' ? 100 : 50)) {
          this.modalLogoError = 'size'

          return this.modalLogoUploadError = true
        }

        reader.readAsDataURL(file)
        reader.onloadend = async () => {
          if (!FilesHelper.checkResolutions(reader.result, 200, 100)) {
            this.modalLogoError = 'dimensions'

            return this.modalLogoUploadError = true
          }

          if (this.agentId) {
            const formData = new FormData()
            formData.append("file", file)

            const response = await this.setPartnerLogo({ id: this.agentId, formData })

            if (response.success) {
              this.getAgentData()
            }
          } else {
            this.file = file
            this.logo = reader.result
          }
        }
      }
    }
  }
})
</script>

<style lang="scss" src="./PartnershipsForm.scss" />